import React from "react";
import "../styles/Footer.css";
import { FaFacebookF, FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt, FaYoutube } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">

      <div className="footer-container">

        
        <div className="footer-col">
          <h2 className="footer-logo">Onsite Interiors</h2>
          <p>
            We create elegant, functional and modern interior spaces 
            tailored to your lifestyle. Transforming homes with passion and creativity.
          </p>

          <div className="social-icons">
           <a href="https://www.facebook.com/OnsiteInteriors" target="_blank" rel="noopener noreferrer">
  <FaFacebookF />
</a>
            <a href="https://www.instagram.com/onsite.interiors.official" target="_blank" rel="noopener noreferrer">
  <FaInstagram />
</a>
            <a href="https://www.youtube.com/@onsiteinteriors" target="_blank" rel="noopener noreferrer">
  <FaYoutube />
</a>
            
          </div>
        </div>

        {/* COLUMN 2 - QUICK LINKS */}
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">About Us</a></li>
            <li><a href="#">Our Projects</a></li>
            <li><a href="#">Designs</a></li>
            <li><a href="#">Contact Us</a></li>
          </ul>
        </div>

        {/* COLUMN 3 - SERVICES */}
        <div className="footer-col">
          <h3>Our Services</h3>
          <ul>
            <li>Interior Design</li>
            <li>Space Planning</li>
      
            <li>Home Makeover</li>
            <li>Furniture Selection</li>
          </ul>
        </div>

        {/* COLUMN 4 - CONTACT INFO */}
        <div className="footer-col">
          <h3>Contact Info</h3>
          <p><FaMapMarkerAlt /> Chandigarh, India</p>
          <p><FaPhone /> +91 6280289442</p>
          <p><FaEnvelope /> onsiteinteriorsindia@gmail.com</p>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Onsite Interiors  Designed & Developed by CallTech Global Team ( A Brand of M.Star Services ). 
      </div>

    </footer>
  );
}

export default Footer;